import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { setAutoCompleteMode } from 'redux/autocomplete';
import Dropdown, { Item as DropdownItem } from './Dropdown';
import { autocompleteModes } from './ToolbarOptions';
import Icon from './Icon';
import { useDispatch, useSelector} from 'react-redux';

const ToolbarDropdownAutocompleteModes = forwardRef(({ options, onOptionClick }, ref) => {
  /* Helpers */
  const dispatch = useDispatch();

  /* Selectors */
  const mode = useSelector((state) => state.autocomplete.mode);

  /* Functions */
  const optionClickHandler = (option) => {
    dispatch(setAutoCompleteMode(option.key));
    onOptionClick(option);
  };

  return (
    <Dropdown ref={ref} position='top' align='center' type='tooltip'>
      <Wrapper>
        {options.map((option, index) =>
          <Item
            key={option.key}
            active={option.key === mode}
            onClick={() => optionClickHandler(option)}
          >
            <Icon name={option.icon} />
            <Label>{option.label}</Label>
          </Item>
        )}
      </Wrapper>
    </Dropdown>
  );
});

export default ToolbarDropdownAutocompleteModes;

ToolbarDropdownAutocompleteModes.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  onOptionClick: PropTypes.func
};

ToolbarDropdownAutocompleteModes.defaultProps = {
  onOptionClick: () => {},
  options: autocompleteModes,
};

const Item = styled(DropdownItem)`
  color: var(${p => p.active ? '--lizzy-blue' : '--lizzy-black'});
`;

const Wrapper = styled.ul`
  all: unset;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  margin: -6px;

  &::before {
    position: absolute;
    content: '';
    width: 0; 
    height: 0; 
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid var(--lizzy-white);
    bottom: -6px;
    left: 50%;
    margin-left: -6px;
    z-index: 12;
  }
  
  ${Item} {
    svg {
      width: 22px;
      height: 22px;
    }
  }
`;

const Label = styled.span``;